import { render, staticRenderFns } from "./trackDetail.vue?vue&type=template&id=58e17b95&scoped=true"
import script from "./trackDetail.vue?vue&type=script&lang=js"
export * from "./trackDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e17b95",
  null
  
)

export default component.exports